import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Spinner, Alert } from 'react-bootstrap';
import SignInGate from './SignInGate';

const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SignInGate />;
  }

  if (user?.role !== 'admin') {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Alert variant="danger" className="text-center">
          <Alert.Heading>Access Denied</Alert.Heading>
          <p>You must be an admin to view this page.</p>
          <Link to="/" className="btn btn-outline-danger">Return Home</Link>
        </Alert>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
